import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomSelect from "../CustomComponents/CustomSelect";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import Tooltip from '@mui/material/Tooltip';
import {logger} from '../../utils';



export default function DiscountDialog({ handleDiscountDialogCallback, data}) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [discountList, setDiscountList] = React.useState([]);
    const [ValueAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState([]);

    const initialValues = {
        discount: 0,
        start: '',
        end: '',
        isActive: false

    };

    const validFormSchema = Yup.object({
        discount: Yup
            .string('Enter a discount')
            .required('discount required'),
        start: Yup
            .date("Enter a start date for the amendment mm/dd/yyyy")
            .required("Start date required mm/dd/yyyy"),
        end: Yup
            .date("Enter an end date for the amendment mm/dd/yyyy")
            .required("End date required mm/dd/yyyy"),
        isActive: Yup
            .boolean()
    })

	const handleEdit = () => {
		for (var i = 0; i < discountList.length; i++) {
			logger('discountList', discountList)
			var item = discountList[i];
			if (moment(item.EndDate).isBefore(moment(item.StartDate))) {
				var tempAlert = [];
				tempAlert.push("For discount " + item.Discount + " EndDate is less than StartDate, Please verify the dates");
				setAlertText(tempAlert);
				setAlert(true);
				return;
			}
            logger("item ", item);
			if (item.IsActive === 0) continue;
			for (var j = 0; j < discountList.length; j++) {
				var r = discountList[j];
				if (i === j || r.IsActive === 0) continue;
				if (moment(item.EndDate).isSame(r.EndDate)
					|| moment(item.StartDate).isSame(r.StartDate)
					|| moment(item.EndDate).isBetween(r.StartDate, r.EndDate)
					|| moment(item.StartDate).isBetween(r.StartDate, r.EndDate)
					|| moment(r.EndDate).isBetween(item.StartDate, item.EndDate)
					|| moment(r.StartDate).isBetween(item.StartDate, item.EndDate)) {
					var tempAlert = [];
					tempAlert.push("Discount is already available within same dates, Please verify the dates");
					setAlertText(tempAlert);
					setAlert(true);
					return;
				}

			}
		}
		
		var editedDiscountList = [];
		for (var i = 0; i < discountList.length; i++) {
			if (discountList[i].Edited === 1) {
				editedDiscountList.push(discountList[i]);
			}
		}


		logger('discountList', discountList);
		logger('edited discountList', editedDiscountList);
		fetch(`api/Discount`, {
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ Discount: editedDiscountList })
		})
		handleClose();
		setRefresh(true);
	};
    
    const handleAlertClose = () => {
        setAlert(false);
        setAlertText([]);
    };

    const onTrigger = React.useCallback((values) => {
        logger("new values ", values);
		var StartDate = moment(values.start);
        var EndDate = moment(values.end);
        var IsActive = values.isActive;
        
        if (moment(EndDate).isBefore(moment(StartDate))) {
			var tempAlert = [];
			tempAlert.push("EndDate cannot be earlier than StartDate, Please verify the dates");
			setAlertText(tempAlert);
			setAlert(true);
			return;
		}
        
        if (IsActive){
			for (var i = 0; i < discountList.length; i++) {
				logger('discountList while save', discountList)
				var item = discountList[i];
                logger("item ", item);
                logger("item active ", item.IsActive);
				
				if (item.IsActive === 1 && (moment(StartDate).isSame(item.StartDate) || moment(EndDate).isSame(item.EndDate)
					|| moment(item.EndDate).isBetween(moment(StartDate), moment(EndDate))
					|| moment(item.StartDate).isBetween(moment(StartDate), moment(EndDate))
					|| moment(EndDate).isBetween(moment(item.StartDate), moment(item.EndDate))
					|| moment(StartDate).isBetween(moment(item.StartDate), moment(item.EndDate)))) {
					var tempAlert = [];
					tempAlert.push("Discount is already available within same dates, Please verify the dates");
					setAlertText(tempAlert);
					setAlert(true);
					return;
				}
			}
		}
		
        const msg = {
            SiteID: data.ID,
            Discount: values.discount,
            StartDate: moment(values.start),
            EndDate: moment(values.end),
            IsActive: values.isActive
        };

        handleDiscountDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        logger(data)        
        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleIsActiveChange = (index) => () => {
        const temp = [...discountList]
        temp[index].IsActive = temp[index].IsActive ? 0 : 1
        temp[index].Edited = 1
        setDiscountList(temp)
    };

    React.useEffect(() => {

        if (refresh) {
            fetch(`api/Discount/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setDiscountList(json))
            setRefresh(false);
        }

    })

    return (
        <div>
            <Tooltip title="Set Discount" placement="top-end">
                <IconButton color="primary" onClick={handleClickOpen}>
                    <MoneyOffIcon />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                            Discount
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Discount Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-discount">discount</InputLabel>
                                        <OutlinedInput
                                            name="discount"
                                            id="outlined-discount"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.discount}
                                            error={props.touched.discount && Boolean(props.errors.discount)}
                                            helperText={props.touched.discount && props.errors.discount}
                                            label="discount"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-startDate"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.start}
                                            error={props.touched.start && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start Date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-endDate"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.end}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End Date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="isActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.isActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                                <Button onClick={() => {
                                    handleEdit()
                                }}>
                                    Update
                                </Button>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 400, border: "2px solid gray" }} aria-label="simple table">
                                        <TableBody>
                                            {discountList.map((value, index) => (
                                                <TableRow
                                                    key={value.ID}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {value.Discount}%
                                                    </TableCell>
                                                    <TableCell align="right"><TextField
                                                        name="start1"
                                                        id="Start"
                                                        type="date"
                                                        onBlur={props.handleBlur}
                                                        value={moment.utc(value.StartDate).format("yyyy-MM-DD")}
                                                        onChange={(e) => {
                                                            let temp = [...discountList]
                                                            temp[index].StartDate = e.target.value
                                                            temp[index].Edited = 1
                                                            setDiscountList(temp)
                                                        }}
                                                        inputFormat="dd-MM-yyyy"
                                                        renderInput={(params) => <TextField {...params} helperText={null} />}
                                                        label="Start"
                                                    /></TableCell>
                                                    <TableCell align="right">
                                                        <TableCell align="right"><TextField
                                                            name="end1"
                                                            id="End"
                                                            type="date"
                                                            onBlur={props.handleBlur}
                                                            value={moment.utc(value.EndDate).format("yyyy-MM-DD")}
                                                            onChange={(e) => {
                                                                let temp = [...discountList]
                                                                temp[index].EndDate = e.target.value
                                                                temp[index].Edited = 1
                                                                setDiscountList(temp)
                                                            }}
                                                            inputFormat="dd-MM-yyyy"
                                                            renderInput={(params) => <TextField {...params} helperText={null} />}
                                                            label="End"
                                                        /></TableCell>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {value.index}
                                                        <Checkbox
                                                            checked={value.IsActive ? true : false}
                                                            onChange={handleIsActiveChange(index)} />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
            <Dialog
                    open={ValueAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Date Conflict"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText.map((a, index) => {
								return(<p key={index}>{a}</p>)
								})}
			            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            setAlert(false);
                            setAlertText([]);
                        }} autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </div>
    );
}